import { SelectModelModel } from '../../../../select/select-model';

export const AVATAR_SHAPE_MODEL: SelectModelModel = [
  { value: 'circle', item: 'Circular' },
  { value: 'rounded', item: 'Redondeado' },
  { value: 'square', item: 'Cuadrado' },
] as const;

export type AvatarShape = (typeof AVATAR_SHAPE_MODEL)[number]['value'];
